module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEUSURBVEhL7ZM9asNAFISlxg4kbeIuKeIqJK0guHaukTRWkSPkImnSG1fxIVyqMP4Bgw5iDIrk7y0j2FbS4iYaGJY3u++TVruKevkqy/K2qqqMcaUonAyOdzzAlCkOIx9uo9Wa6i7Bt5eC32mqu3q4gT4FWGB3cDbi7nD6PwQpPNgT3qje49ZvnuAjnuNHvBb0LwR8hHM4qSLLxrjeielZU81E/4DmHx9AFlP/Cu5/ruY/E02v9N+odCL7EnSJbSf151poSXsBecMnbA+JldmZFHjjFrUVgAd8wFNFTtRz7WCmqLloHuJvOPeKnKhTcrtd74raCYCdxZVKJ7IXnONEUTgBvcZ2u0aKwgrwhB0NVP47RdEZxx+uUartmzYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-pitchfork/light/24.png
// module id = 2344
// module chunks = 2